import { useAuth } from '../context/AuthContext';

export const usePermissions = () => {
  const { hasPermission } = useAuth();

  const hasAnyPermission = (permissions: string[]): boolean => {
    return hasPermission(permissions);
  };

  const hasAllPermissions = (permissions: string[]): boolean => {
    return permissions.every(permission => hasPermission(permission));
  };

  const isSuperuser = (): boolean => {
    return hasPermission('manage_companies');
  };

  const canManageUsers = (): boolean => {
    return hasPermission('manage_users');
  };

  const canManageSettings = (): boolean => {
    // Only superusers can manage settings
    return isSuperuser();
  };

  const canViewReports = (): boolean => {
    return hasPermission('view_reports');
  };

  const canManageTransactions = (): boolean => {
    return hasPermission('manage_transactions');
  };

  const canManageCustomers = (): boolean => {
    return hasPermission('manage_customers');
  };

  const canManageItems = (): boolean => {
    return hasPermission('manage_items');
  };

  return {
    hasPermission,
    hasAnyPermission,
    hasAllPermissions,
    isSuperuser,
    canManageUsers,
    canManageSettings,
    canViewReports,
    canManageTransactions,
    canManageCustomers,
    canManageItems
  };
};

export default usePermissions;